
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

// Delete a widget definition
export const deleteWidgetDefinition = async (id: string): Promise<boolean> => {
  try {
    const { error } = await supabase
      .from('widget_definitions')
      .delete()
      .eq('id', id);
    
    if (error) throw error;
    
    return true;
  } catch (error) {
    console.error('Error deleting widget definition:', error);
    toast({
      title: "Error",
      description: "Failed to delete widget definition",
      variant: "destructive",
    });
    return false;
  }
};
